import React from "react";

const Footer = () => {
  return (
    <div id="container" className="bg-slate-800 border border-slate-600 mt-10">
      <div className="max-w-[1440px] w-full p-4 ">
        <div className="flex justify-center">
          <strong>Made by SAS😎</strong>
        </div>
      </div>
    </div>
  );
};

export default Footer;
